// Shared submit handler for the wholesale application forms
// (wholesale-steps, contact-ajax, floating-contact). Replaces the old
// native POST to Shopify's /contact — which can't carry file uploads —
// with a fetch() to the custom intake Worker.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function showError(scope, message) {
    var errorEl = scope && scope.querySelector('[data-wholesale-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      alert(message);
    }
  }

  function handleSuccess(form, scope) {
    var successEl = scope && scope.querySelector('[data-wholesale-success]');
    if (successEl) {
      var formWrap = (scope && scope.querySelector('[data-wholesale-formwrap]')) || form;
      formWrap.hidden = true;
      successEl.hidden = false;
      // Some sections gate visibility on this class rather than [hidden]; harmless no-op otherwise.
      successEl.classList.add('is-visible');
    } else {
      window.location.href = form.dataset.redirect || '/pages/form_thanks';
    }
  }

  function resetTurnstile(form) {
    var widget = form.querySelector('.cf-turnstile');
    if (widget && window.turnstile) {
      try { window.turnstile.reset(widget); } catch (e) {}
    }
  }

  function bindForm(form) {
    var scope = form.closest('[data-wholesale-scope]') || form.parentElement;
    var submitBtn = form.querySelector('[type="submit"]');
    var submitLabel = submitBtn ? submitBtn.textContent : '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var errorEl = scope && scope.querySelector('[data-wholesale-error]');
      if (errorEl) errorEl.hidden = true;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var endpoint = form.dataset.endpoint;
      if (!endpoint || endpoint.indexOf('REPLACE') !== -1) {
        showError(scope, 'This form is not configured yet. Please contact us another way.');
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = form.dataset.submittingLabel || 'Submitting…';
      }

      fetch(endpoint, { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok && result.data && result.data.ok) {
            handleSuccess(form, scope);
          } else {
            showError(scope, 'Something went wrong submitting your application. Please try again.');
            resetTurnstile(form);
          }
        })
        .catch(function () {
          showError(scope, 'Something went wrong submitting your application. Please try again.');
          resetTurnstile(form);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-wholesale-form]').forEach(bindForm);
  });
})();
